import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FontFamily,
  FontWeight,
  Space,
  Text,
} from '@gousto-internal/citrus-react'

import type { DisplayPreference } from '@library/api-menu-experience'

type RecipeInformationPreviewProps = {
  displayPreferences: DisplayPreference[]
}

const PREVIEW_IMAGE_HEIGHT = '180px'
const PREVIEW_BODY_MIN_HEIGHT = '100px'

export const RecipeInformationPreview = ({ displayPreferences }: RecipeInformationPreviewProps) => {
  const previewItems = displayPreferences.filter(
    (preference) => preference.selected && preference.example,
  )

  return (
    <Box
      bg={Color.White}
      data-testid="recipe-information-preview"
      style={{
        borderRadius: '4px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
      }}
    >
      <Box bg={Color.ColdGrey_100} height={PREVIEW_IMAGE_HEIGHT} />
      <Box minHeight={PREVIEW_BODY_MIN_HEIGHT} paddingH={3} paddingV={3}>
        <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={4}>
          Recipe name
        </Text>
        {previewItems.length ? (
          <>
            <Space size={1} direction="vertical" />
            <Box display={Display.Flex} alignItems={AlignItems.Center} gap={1} wrap>
              {previewItems.map((item, index) => (
                <React.Fragment key={`${item.type}-${item.example}`}>
                  {index > 0 ? (
                    <Text
                      size={2}
                      fontFamily={FontFamily.Book}
                      fontWeight={FontWeight.Normal}
                      color={Color.ColdGrey_600}
                    >
                      |
                    </Text>
                  ) : null}
                  <Text
                    size={2}
                    fontFamily={FontFamily.Book}
                    fontWeight={FontWeight.Normal}
                    color={Color.ColdGrey_600}
                  >
                    {item.example}
                  </Text>
                </React.Fragment>
              ))}
            </Box>
          </>
        ) : null}
      </Box>
    </Box>
  )
}
